import { useSelfCtx } from '@anyx/common-self';
import { useFeatureFlag } from '@anyx/external-firebase';
import { UnauthorizedMessage } from '@anyx/shared-ui';

export const useAdminSectionPagePermission = () => {
  const { self } = useSelfCtx();
  const id = self?.id;
  const flag = useFeatureFlag('ac_enable_admin_section_page', { as: 'json' });
  const flagValue = flag?.value as { enabledUserId?: string[] } | undefined;
  return flagValue?.enabledUserId?.includes(id);
};

export const AdminSectionPagePermission = ({ children }: { children: React.ReactNode }) => {
  const isAllowed = useAdminSectionPagePermission();

  return isAllowed ? children : <UnauthorizedMessage />;
};
